import service from './service'

class APIList {
  constructor() {
    this.prefix = '/security'
  }
  /**
   * @desc 获取过滤用户列表
   */
  getUserList() {
    return service.get(this.prefix + '/users')
  }
  /**
   * @desc 获取全部用户列表
   */
  getAllUserList(id) {
    return service.get(this.prefix + '/users/listByUser?id=' + id)
  }
  /**
   * @desc 获取用户详情
   */
  getUserDetail(params) {
    return service.get(this.prefix + '/users/' + params)
  }
  /**
   * @desc 新增用户
   */
  saveUser(params) {
    return service.post(this.prefix + '/users', params)
  }
  /**
   * @desc 修改用户
   */
  updateUser(params) {
    return service.put(this.prefix + '/users/' + params.userId, params)
  }
  /**
   * @desc 注销用户
   */
  deleteUser(userId) {
    return service.delete(this.prefix + '/users/' + userId)
  }

  /**
   * @desc 获取用户组列表
   */
  getGroupList() {
    return service.get(this.prefix + '/groups')
  }
  /**
   * @desc 获取用户组列表(包含用户列表)
   */
  getGroupAndUserList() {
    return service.get(this.prefix + '/groups/users')
  }
  /**
   * @desc 获取用户组详情
   */
  getGroupDetail(params) {
    return service.get(this.prefix + '/groups/' + params)
  }
  /**
   * @desc 新增用户组
   */
  saveGroup(params) {
    return service.post(this.prefix + '/groups', params)
  }
  /**
   * @desc 修改用户组
   */
  updateGroup(id, params) {
    return service.put(this.prefix + '/groups/' + id, params)
  }
  /**
   * @desc 删除用户组
   */
  deleteGroup(groupId) {
    return service.delete(this.prefix + '/groups/' + groupId)
  }

  /**
   * @desc 授权
   */
  addResourcesOwners(id, type, params) {
    return service.put(
      this.prefix + '/resources/' + type + '/' + id + '/owners/',
      params
    )
  }

  /**
   * @desc 获取拥有资源的用户\用户组列表
   */
  getResourcesOwners(type, id) {
    return service.get(this.prefix + '/resources/' + type + '/' + id)
  }
  /**
   * @desc 登录
   */
  login(params) {
    return service.post(this.prefix + '/auth/login', params)
  }
  /**
   * @desc 退出
   */
  logout() {
    return service.get(this.prefix + '/auth/logout')
  }
  /**
   * @desc 企业注册
   */
  logon(params) {
    return service.post(this.prefix + '/security/enter/enterRegist', params)
  }
  /**
   * @desc 获取门禁用户列表
   */
  getUserListDoor() {
    return service.get('/resources/getUsers')
  }
  /**
   * @desc 获取门禁用户组列表
   */
  getUserGroupListDoor() {
    return service.get('/resources/getGroups')
  }
  getRightList(id) {
    return service.get('/resources/' + id)
  }
  /**
   * @desc 获取门禁列表
   */
  getDoorList() {
    return service.get(this.prefix + '/door/getAll')
  }
  /**
   * @desc 重置用户密码（仅限高级管理员使用）
   */
  resetPassword(userId) {
    return service.put('/auth/users/' + userId + '/reset-password', {})
  }
  /**
   * @desc 修改用户密码（用户本人使用，需提供当前密码）
   * @param {Integer} userId - 用户ID
   * @param {String} currentPassword - 当前密码
   * @param {String} newPassword - 新密码
   */
  updatePassword(userId, currentPassword, newPassword) {
    return service.put('/auth/users/' + userId + '/change-password', {
      currentPassword,
      newPassword
    })
  }

}

export default new APIList()



// WEBPACK FOOTER //
// ./src/service/authorityService.js